/* global $ */

import Freezeframe from 'freezeframe';

const IS_TOUCH_DEVICE =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  window.matchMedia('(pointer:coarse)').matches;

class PeopleCard {
  constructor($el) {
    if (IS_TOUCH_DEVICE) {
      $('body').addClass('is-touch-device');
    } else {
      $('body').removeClass('is-touch-device');
    }
    this.$window = $(window);
    this.$container = $el;
    this.id = this.$container.attr('id');
    this.gifId = this.$container.find('.freezeframe').attr('id');

    this.isInitialized = false;
    this.isMobile = false;
    this.isStartAnimation = false;
    if (this.$container.find('.Image--absolute').length) {
      this.$gif = new Freezeframe(`#${this.gifId}`, {
        trigger: false,
      });
      setTimeout(() => {
        this.$gif.start();
        this.$gif.stop();

        if (!IS_TOUCH_DEVICE) {
          this.$container.on('mouseover', () => {
            this.$gif.start();
          });
          this.$container.on('mouseout', () => {
            this.$gif.stop();
          });
        }

        this.isInitialized = true;
      }, 100);

      this.mediaQuery = window.matchMedia('(max-width: 768px)');
      this.$window.on('resize', () => {
        this.onWindowResize();
      });
      this.onWindowResize();
    }
  }
  onWindowResize() {
    if (this.mediaQuery.matches) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }
  update() {
    if (this.isInitialized) {
      if (IS_TOUCH_DEVICE) {
        clearInterval(this.fadeoutTimer);

        if (!this.isStartAnimation) {
          this.isStartAnimation = true;
          this.$gif.start();
        }

        this.$container.addClass('show-animate');

        this.fadeoutTimer = setTimeout(() => {
          this.$gif.stop();
          this.$container.removeClass('show-animate');
          this.isStartAnimation = false;
        }, 800);
      } else {
        if (this.isStartAnimation) {
          this.isStartAnimation = false;
          this.$container.removeClass('show-animate');
        }
      }
    }
  }
}

class PagePeople {
  constructor(mainApp) {
    this.$window = $(window);
    this.mainApp = mainApp;

    // this.firstView = new FirstView();
    this.peoples = [];
    $('.PeopleCard').each((i, e) => {
      this.peoples.push(new PeopleCard($(e)));
    });
    this.isInitialized = false;
  }
  onLoadWindow() {
    // this.firstView.show();
    this.isInitialized = true;
  }
  onWindowResize() {
    // this.firstView.resize();
  }
  onWindowScroll() {
    if (this.$window.scrollTop() > 5) {
      if (this.isInitialized) {
        for (let i = 0; i < this.peoples.length; i++) {
          this.peoples[i].update();
        }
      }
    }
  }
  destroy() {}
}

export default PagePeople;
